import classNames from "classnames";
import { usePopup } from "../../../components/popup/popup";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { Button } from "../../../components/button/button";
import { ClockSmallIcon } from "../../../assets/icons";

import styles from "./knowledgeBaseTestsPage.module.css";
import { useEffect, useState } from "react";
import { Text } from "../../../components/text/text";

const getDaysText = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return `${n} день`;
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return `${n} дня`;
    return `${n} дней`;
};

const getHoursText = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return `${n} час`;
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return `${n} часа`;
    return `${n} часов`;
};

const getMinutesText = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return `${n} минута`;
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return `${n} минуты`;
    return `${n} минут`;
}

const getSecondsText = (n) => {
    if (n % 10 === 1 && n % 100 !== 11) return `${n} секудна`;
    if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return `${n} секунды`;
    return `${n} секунд`;
}

export const Test = ({ data, materialId }) => {
    const openPage = useOpenPage();
    const [Popup, open, close] = usePopup();

    const clickHandler = () => {
        if (data.isResolved === true) return;

        const openTargetPage = openPage(`/knowledge/${materialId}/tests/${data.id}`);

        if (data.isResolved === null) {
            openTargetPage();
        } else if (data.isResolved === false) {
            if (Date.now() - data.completedAt.getTime() >= process.env.REACT_APP_RETRY_TIMEOUT) {
                openTargetPage();
            } else {
                open();
            }
        }
    }

    const nextTry = new Date(data.completedAt.getTime() + parseInt(process.env.REACT_APP_RETRY_TIMEOUT));
    const [delta, setDelta] = useState(nextTry.getTime() - Date.now());
    const days = Math.floor(delta / (24 * 60 * 60 * 1000));
    const hours = Math.floor((delta % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((delta % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((delta % (60 * 1000)) / (1000));

    useEffect(() => {
        const intervalId = setInterval(() => {
            setDelta(prev => Math.max(prev - 1000, 0));
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <>
            <div className={classNames(styles.test, { [styles.success]: data.isResolved, [styles.fail]: data.isResolved !== null && !data.isResolved })}>
                <Text as="h2" variant="captionStrong" size={12} className={styles.test_text} clamp={2}>{data.name}</Text>
                <div className={styles.test_action_block}>
                    <div className={styles.test_data}>
                        <Text as="div" variant="bodyStrong" className={styles.test_experience} size={15} weight={700} lineHeight="1">{data.rewardExp}XP</Text>
                    </div>
                    <Button
                        view="thin"
                        type={data.isResolved === null ? "primary" : (data.isResolved ? "done" : "destructive")}
                        text={data.isResolved === null ? "Пройти тест" : (data.isResolved ? "Пройдено" : "Не пройдено")}
                        onClick={clickHandler}
                    />
                </div>
            </div>
            {
                data.isResolved === false &&
                <Popup>
                    <div className={styles.explanation_header}>
                        <Text as="div" variant="h1" className={styles.explanation_title} align="center">
                            Тест был пройден неверно 
                        </Text>
                        <Text as="div" variant="body" className={styles.explanation_subtitle} align="center">
                            Хорошо повтори все материалы и пройди тест заново через 15 минут.
                        </Text>
                    </div>

                    <div className={styles.explanation_info}>
                        <div className={styles.explanation_next_time}>
                            <ClockSmallIcon className={styles.explanation_info_icon} />
                            <Text as="div" variant="bodyStrong" className={styles.explanation_info_text}>
                                {(days > 0) ? getDaysText(days) : null} {(hours > 0) ? getHoursText(hours) : null} {(minutes > 0) ? getMinutesText(minutes) : null} {getSecondsText(seconds)}
                            </Text>
                        </div>
                    </div>

                    <Button type="primary" text="Хорошо" onClick={close} />
                </Popup>
            }
        </>
    )
}